const revealNelmoreni = () => {
  const items = document.querySelectorAll('.nel-reveal:not([data-nel-ready])');
  if (!items.length) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  items.forEach((item) => {
    item.dataset.nelReady = 'true';
    observer.observe(item);
  });
};

document.addEventListener('DOMContentLoaded', revealNelmoreni);
document.addEventListener('shopify:section:load', revealNelmoreni);
